export const AwarenessEventType = 'awarenessEvent';
